/**
 * @desc 根据周查询周计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.WeekRequest,
): Promise<defs.StandardReturn<defs.PlanWeekInfoResponse>> {
  return defHttp.post({
    url: '/web/plan/week/queryPlanInfoByWeek',
    data,
  });
}

export function mock(
  data: defs.WeekRequest,
): Promise<defs.StandardReturn<defs.PlanWeekInfoResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/week/queryPlanInfoByWeek',
    data,
  });
}
